/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_RadioInputs */



/**
* | output |
* | --- |
* | "Improve radio transmission" |
*
* @param {Improve_RadioInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const improve_radio = /** @type {((inputs?: Improve_RadioInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_RadioInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Improve radio transmission")
	return /** @type {LocalizedString} */ ("Améliorer la transmission radio")
});